import ModuleMixin from '@/Mixins/ModuleMixin'
import { EventBus } from '@/app'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.openpay',
            cardForm: 'openpay-card-form',
            publicEnviroments: {}
        }
    },

    methods: {
        openCardForm(successHandler = () => {}, errorHandler = () => {}) {
            EventBus.$emit(
                'generic.modal.show',
                'openpay-card-form',
                {
                    title: 'Capturar tarjeta',
                    modalProps: {
                        size: 'lg'
                    },
                    component: this.cardForm,
                    componentEvents: {
                        'successHandler': successHandler,
                        'errorHandler': errorHandler
                    }
                }
            )
        },

        closeCardForm() {
            EventBus.$emit('generic.modal.hide', 'openpay-card-form')
        },

        loadScript() {
            return this.$Util.loadDynamicResource(
                'openpay-source',
                'script',
                'https://js.openpay.mx/openpay.v1.min.js',
                {type: 'text/javascript'}
            )
            .then(() => this.$Util.loadDynamicResource(
                'openpay-data',
                'script',
                'https://js.openpay.mx/openpay-data.v1.min.js',
                {type: 'text/javascript'}
            ))
            .then(() => {
                OpenPay.setId(this.publicEnviroments.merchant_id)
                OpenPay.setApiKey(this.publicEnviroments.public_key)
                OpenPay.setSandboxMode(! this.publicEnviroments.production_mode)
            })
        }
    },

    created() {
        this.$models.$payment.addForm('openpay.card.web', 'openpay-card-web-payment-form')
        this.publicEnviroments = this.$state.config_openpay.publicEnviroments
    }
}
